import { Flag, Menu, Search } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function Topbar({
  title,
  section,
  onOpenNav,
  onOpenSearch,
}: {
  title?: string
  section?: string
  onOpenNav?: () => void
  onOpenSearch?: () => void
}) {
  const { permissions } = useAuth()
  return (
    <header className="admin-topbar">
      <div className="admin-topbar-context">
        <button type="button" className="admin-icon-button admin-mobile-menu" onClick={onOpenNav} aria-label="Open navigation">
          <Menu aria-hidden="true" />
        </button>
        <div className="admin-breadcrumb">
          {section && section !== 'Workspace' && <span>{section}</span>}
          <strong>{title || 'Overview'}</strong>
        </div>
      </div>

      <button type="button" className="admin-global-search" onClick={onOpenSearch}>
        <Search aria-hidden="true" />
        <span>Search people, reports, or tools</span>
        <kbd>⌘ K</kbd>
      </button>

      {permissions?.viewReports ? (
        <Link to="/trust-safety/reports" className="admin-review-shortcut">
          <Flag aria-hidden="true" />
          <span>Review queue</span>
        </Link>
      ) : <span />}
    </header>
  )
}
